import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./StatusBar.css";

export const StatusBar = ({ scrollRef }) => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollPercentage, setScrollPercentage] = useState(0);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const { scrollTop, scrollHeight, clientHeight } =
                    scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                const percentage =
                    maxScroll > 0
                        ? Math.round((scrollTop / maxScroll) * 100)
                        : 0;

                setScrollPosition(scrollTop);
                setScrollPercentage(percentage);
            }
        };

        const scrollElement = scrollRef.current;
        if (scrollElement) {
            scrollElement.addEventListener("scroll", handleScroll);
            handleScroll(); // Initial call
        }

        return () => {
            if (scrollElement) {
                scrollElement.removeEventListener("scroll", handleScroll);
            }
        };
    }, [scrollRef]);

    const getPageName = () => {
        if (location.pathname === "/") return "ABOUT";
        if (location.pathname === "/posts") return "POSTS";
        if (location.pathname.startsWith("/posts/")) {
            return "POST";
        }
        return "UNKNOWN";
    };

    const getScrollIndicator = () => {
        if (scrollPercentage === 0) return "Top";
        if (scrollPercentage === 100) return "Bot";
        return `${scrollPercentage}%`;
    };

    return (
        <div className="status-bar">
            <div className="status-left">
                <span className="status-mode">{getPageName()}</span>
                <span className="status-path">{location.pathname}</span>
            </div>
            <div className="status-right">
                <span className="status-keys">
                    <span className="key">j/k</span> scroll
                    <span className="separator">|</span>
                    <span className="key">gg/G</span> top/bot
                    <span className="separator">|</span>
                    <span className="key">/</span> search
                    <span className="separator">|</span>
                    <span className="key">:</span> cmd
                </span>
                <span className="status-scroll">{getScrollIndicator()}</span>
            </div>
        </div>
    );
};
